module.exports = __webpack_public_path__ + "static/vbv-9e067250e4bbf4394e35380c70fa91d9.jpg";